<template>
  <div ref="vscroll" :class="$style.vscroll">
    <div
      ref="topBlock"
      :class="$style.block"
      :style="{
        height: `${this.topHeight}px`
      }"
    ></div>
    <template v-for="(option, index) in batch">
      <slot :option="option" :index="index + startIndex"></slot>
    </template>
    <div
      ref="botBlock"
      :class="$style.block"
      :style="{
        height: `${this.botHeight}px`
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'VirtualScroll',
  props: {
    wrapper: {
      required: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
      required: true,
    },
  },
  beforeDestroy() {
    if (this.target) {
      this.target.removeEventListener('scroll', this.scrollListener);
    }
  },
  data() {
    return {
      target: null,
      scrollTop: 0,
      wrapperHeight: 0,
    };
  },
  computed: {
    startIndex() {
      return Math.max(Math.ceil(this.scrollTop / this.height) - 1, 0);
    },
    batchSize() {
      return Math.floor(this.wrapperHeight / this.height) + 1;
    },

    endIndex() {
      return Math.min(this.startIndex + this.batchSize, this.options.length - 1) + 1;
    },

    batch() {
      return this.options.slice(this.startIndex, this.endIndex);
    },

    topHeight() {
      return this.startIndex * this.height;
    },

    botHeight() {
      return (this.options.length - 1 - this.endIndex) * this.height;
    },
  },
  watch: {
    options() {
      this.scrollListener();
    },
    wrapper: {
      immediate: true,
      handler(value) {
        if (this.target) {
          this.target.removeEventListener('scroll', this.scrollListener);
        }
        if (value) {
          this.target = value.$el ? value.$el : value;
          this.target.addEventListener('scroll', this.scrollListener);
          this.scrollListener();
        }
      },
    },
  },
  methods: {
    scrollListener() {
      this.scrollTop = this.target.scrollTop;
      this.wrapperHeight = this.target.getBoundingClientRect().height;
    },
  },
};
</script>

<style lang="sass" module>
  .vscroll
    width: auto
  .block
    width: auto
</style>
